<div class="video-container">
  <div id="player"
       style="position: fixed; right: 0; bottom: 0; min-width: 100%; min-height: 100%; width: auto; height: auto; background-color: black; z-index: 1000;"></div>
  <app-overlay-message-trailer #overlayMessageTrailer></app-overlay-message-trailer>
</div>


